import request from 'utils/axios/service';
import { endpoints } from '../constants'

class DashboardService {
    getTotalDashboard() {
        return request.get(endpoints.GETDASHBOARD)
    }
}

export default DashboardService